import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #040404;
    --navy: #070709; //main   
    --light-navy: #121216; //card background
    --lightest-navy: #233554; //Lines and shit
    --navy-shadow: rgba(27, 22, 2, 0.7);
    --dark-slate: #465670; //scrollbarnp
    --slate: #c8c8d2; //tags
    --light-slate: #bcbcbc; //socials
    --lightest-slate: #FFFFFF;//name_headers
    --white: #e3e3e3; //UNKNOWN
    --green: #26beff; //highlights CHANGE ONLY THIS FOR ENTIRE THEME YAY
    --green-tint: rgba(27, 90, 194, 0.1); //filters
    --pink: #f57dff;
    --blue: #515158;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
